export var mutations = {
    setComments: function (s, comments) { return s.comments = comments; },
    addComment: function (s, comment) { return s.comments.push(comment); },
    setCommenters: function (s, commenters) { return s.commenters = commenters; },
    addCommenter: function (s, commenter) { return s.commenters.push(commenter); },
    setLoading: function (s, loading) { return s.loading = loading; },
};
